import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const SiteViewContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.maineWidth ?? "100%"};
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: ${(props) => props.marginLeft ?? "0px"};
  margin-right: auto;
  padding: 1.375rem;
  padding-right: 2rem;
  padding-top: 0px;
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const FlexRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  > div {
    margin-right: 1rem;
  }
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gridGap ?? "1.25rem;"};
  margin-bottom: ${(props) => props.marginBottom ?? "10px"};
  font-weight: normal;
  margin-top: ${(props) => props.marginTop ?? "10px"};
`;

export const ButtonWrapper = styled.div`
  text-align: right;
`;

export const ButtonData = styled(BaseButton)`
  background: ${(props) => (props?.color ? props.color : "#15aee5")};
  border: ${(props) =>
    props?.color ? "1px solid" + props.color : "1px solid #15aee5"};
  margin-right: ${(props) => (props?.marginRight ? props.marginRight : "0px")};
  font-weight: normal;
  width: auto;
  padding: 3px 10px;
  font-size: 14px;
  font-family: lato;
`;

export const ParentDetail = styled.h2`
  color: #004c7f;
  font-size: 13px;
  font-family: lato;
  font-style: italic;
  text-transform: initial;
  margin-bottom: 10px;
  line-height: 1;
  margin-top: 3px;
  font-weight: bold !important;
  display: inline-flex;
`;

export const CommunicationButtonWrapper = styled.div`
  text-align: right;
  position: relative;
  display: inline-block;
`;

export const MarginBottom = styled.div`
  margin-bottom: 30px;
`;

export const FlexRowHeader = styled.div`
  background-color: #008395;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  display: flex;
  font-size: 16px;
  font-weight: 700;
  border-radius: 5px 5px 0px 0px;
`;

export const Title = styled.h3`
  color: white !important;
  text-align: left;
  width: auto;
  font-family: "Lato";
  font-size: 20px;
  line-height: 20px;
  margin: 0;
  font-weight: ${(props) => props.fontWeight ?? "normal"};
`;

export const ErrorDiv = styled.div`
  height: 35px;
  border: solid 1px red;
  padding: 7px;
`;

export const GridItem = styled.div`
  border: 1px solid rgba(10, 73, 134, 0.3);
  line-height: 2rem;
  text-align: ${(props) => props.textAlign ?? "center"};
  color: #474747;
  font-weight: ${(props) => props.fontWeight ?? "400"};
  background-color: ${(props) => props.backgroundColor ?? "#fff"};
  padding: 10px;
  font-size: ${(props) => props.fontSize ?? "16px"};
`;

export const GridSubItem = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-style: ${(props) => props.fontStyle ?? "italic"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-size: ${(props) => props.fontSize ?? "14px"};
  text-align: ${(props) => props.textAlign ?? "left"};
`;
export const QuoteInfoAndConditionsInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: ${(props) =>
    props.boxShadow ?? "2px 2px 4px 1px rgba(0, 76, 127, 0.25)"};
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  padding: ${(props) => props.padding ?? "20px"};
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
`;

export const GridSubLabel = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-weight: 700;
  font-size: ${(props) => props.fontSize ?? "#0a4986"};
  text-align: left;
`;
